import type { ReactNode } from 'react';

import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';

interface Props {
  description: ReactNode;
  href: string;
  fileName: string;
}

export const DownloadSampleCSV = (props: Props) => {
  return (
    <div className="flex flex-col bg-gray-200 rounded-sm gap-4 py-5 px-6">
      <Typo type="body2" className="text-gray-700">
        {props.description}
      </Typo>

      <a
        href={props.href}
        download={props.fileName}
        target="_self"
        style={{ width: 'fit-content' }}
      >
        <Button
          variant="outlined"
          sizeType="m"
          style={{ width: 'fit-content' }}
        >
          Download sample CSV
        </Button>
      </a>
    </div>
  );
};
